import { GppGoodSharp } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { GetCompanyResponseDto } from '../../../services/dtos/GetCompanyResponseDto';
import { FC } from 'react';
import { useTranslation } from 'next-i18next';

interface Props {
  company: GetCompanyResponseDto;
}

export const CertificationsOrMembershipsCompanyIcon: FC<Props> = ({
  company,
}) => {
  const { t } = useTranslation(['directory', 'common']);
  if (
    company.company.certifications?.length > 0 ||
    company.company.memberships?.length > 0
  ) {
    return (
      <Tooltip title={t('directory:company:hasCertifications')} arrow>
        <GppGoodSharp
          sx={{
            color: '#2EAEC1',
          }}
        />
      </Tooltip>
    );
  }

  return null;
};
